import { ConnectedPosition } from '@angular/cdk/overlay';
import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, forwardRef, input, Input } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { NgOption, NgSelectModule } from '@ng-select/ng-select';

import { BaseFormControlComponent } from '@shared/components/base-form-control/base-form-control';
import { TooltipDirective } from '@shared/directives/tooltip.directive';
import { Utils } from '@shared/utils/utils';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, NgClass, NgSelectModule, TooltipDirective],
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultiSelectDropdownComponent),
    },
    {
      multi: true,
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => MultiSelectDropdownComponent),
    },
  ],
  selector: 'aux-multi-select-dropdown',
  styleUrl: 'multi-select-dropdown.component.scss',
  templateUrl: './multi-select-dropdown.component.html',
})
export class MultiSelectDropdownComponent extends BaseFormControlComponent<null | string> {
  multiple = input(true);

  @Input() appendTo: string = 'body';
  @Input() bindLabel = 'label';
  @Input() bindValue = 'value';
  @Input() classNames = '';
  @Input() clearable = true;
  @Input() closeOnSelect = true;
  @Input() customOption = false;
  @Input() disabled = false;
  @Input() getCustomOptionLabel?: (option: unknown) => string;
  @Input() items: NgOption[] = [];
  @Input() labelClassName = '';
  @Input() loading = false;
  @Input() maximumItemsToDisplay = 1;
  multipleVendorId = `multi-select-${Utils.uuid()}`;
  @Input() optionTooltipPositions: ConnectedPosition[] = [
    // Top position strategy
    {
      offsetY: -8,
      originX: 'center',
      originY: 'top',
      overlayX: 'center',
      overlayY: 'bottom',
    },
    // Bottom position strategy
    {
      offsetY: 8,
      originX: 'center',
      originY: 'bottom',
      overlayX: 'center',
      overlayY: 'top',
    },
  ];
  @Input() prefix? = '';
  @Input() prefixClick?: VoidFunction;
  @Input() requiredLabel = false;
  @Input() searchable = false;

  castToNgOption(option: unknown): NgOption[] {
    return option as NgOption[];
  }

  get classes(): string {
    let classes = '';

    if (this.prefix) {
      classes += 'no-border-right';
    }

    if (this.classNames) {
      classes += ` ${this.classNames}`;
    }

    return classes.trim();
  }

  getOptionLabel(option: NgOption): string {
    if (this.getCustomOptionLabel) {
      return this.getCustomOptionLabel(option);
    }

    if (this.customOption) {
      return option.title || '';
    }

    return option[this.bindLabel] || '';
  }
}
